import React, {Component} from 'react'
import {Table, Row, Col, Button, message, Popconfirm, Upload, Icon} from 'antd';
import {
    baseUrl,
    reqKtGetBoxNos,
    reqKtGetDeclares,
    reqKtCreateDeclare,
    reqKtUpdateDeclare,
    reqKtDelDeclare,
    reqFileDel
} from '../../api'
import DeclareModal from './declare-modal.jsx'
import './index2.less';
import authorizeBase from "../../components/authorize/authorizeBase";
import LinkButton from '../../components/link-button'
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton);

export default class OrderDeclare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            declareList: [],
            boxNoList: [],
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.getProducts({id: orderId});
        if (!this.props.readOnly) {
            this.getBoxNoList(orderId);
        }
        this.setState({orderId, readOnly: this.props.readOnly});
    }

    getProducts = async (values = {}, pageNum = 1, pageSize = 10) => {
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqKtGetDeclares(values);
        if (result.code == '200') {
            this.setState({
                pageNum: pageNum,
                pageSize: pageSize,
                total: result.data.total,
                declareList: result.data.rows,
            })
        } else {
            message.error(result.message)
        }
    };
    getBoxNoList = async (orderId) => {
        const result = await reqKtGetBoxNos(orderId);
        if (result.code === 200) {
            if (result.data == null || (result.data != null && result.data.length == 0)) {
                message.error("无可用的集装箱号")
            }
            this.setState({boxNoList: result.data});
        } else {
            message.error(result.message)
        }
    };
    // 新增
    clickAdd = () => {
        this.setState({
            view: true,
            action: 'add',
            record: null,
        })
    };
    // 修改
    clickUpdate = (data) => {
        this.setState({
            view: true,
            action: 'update',
            record: data
        });
    };
    // 新增
    createDeclare = async (po) => {
        const {pageNum} = this.state;
        const result = await reqKtCreateDeclare(po);
        if (result.code === 201) {
            this.getProducts({id: po.orderId}, pageNum)
        } else {
            message.error(result.message);
        }
    };
    // 更新
    updateDeclare = async (po) => {
        const {pageNum, record} = this.state;
        po.id = record.id;
        const result = await reqKtUpdateDeclare(po);
        if (result.code === 200) {
            this.getProducts({id: po.orderId}, pageNum)
        } else {
            message.error(result.message);
        }
    };
    // 删除
    delDeclare = async (id) => {
        const {pageNum, orderId} = this.state;
        const result = await reqKtDelDeclare(id);
        if (result.code === 200) {
            this.getProducts({id: orderId}, pageNum)
        } else {
            message.error(result.message);
        }
    };
    onOk = data => {
        const {action, orderId} = this.state;
        data.orderId = orderId;
        if (action === 'add') {
            this.createDeclare(data);
        } else {
            this.updateDeclare(data);
        }
        this.onCancel();
    };
    onCancel = () => {
        this.setState({view: false})
    };
    handleChange = (file) => {
        if (file.file.status !== 'uploading') {
            const {pageNum, orderId} = this.state;
            this.getProducts({id: orderId}, pageNum);
        }
    };
    handleRemove = async (info) => {
        let fileId = info.fileId;
        let objectId = info.objectId;
        if (!fileId) {
            fileId = info.response.data.id;
            objectId = info.response.data.objectId;
        }
        const result = await reqFileDel({
            "fileId": fileId,
            "orderId": objectId,
        });
        if (result.code !== 200) {
            message.error(result.message);
        }
    };
    handleBeforeUpload = (f, fList, fileList) => {
        return new Promise((resolve, reject) => {
            if (fileList.length > 0) {
                message.info("只能上传一个文件");
                return reject(false);
            }
            if (f.size > 10000000) {
                message.info("只能上传10M内文件");
                return reject(false);
            }
            //限制上传类型
            const typeImg = ["gif", "png", "jpg", "jpeg", "docx", "doc", "pdf", "xls", "xlsx", "rar", "zip"];
            const type = f.name.indexOf(".") != -1 ? f.name.substring(f.name.lastIndexOf(".") + 1, f.name.length) : null;
            if ( type.includes('image/') || !typeImg.includes(type)) {
                message.info("不支持该文件类型");
                return reject(false);
            }
            return resolve(true);
        });
    };

    render() {
        const {orderId, pageNum, pageSize, total, view, action, record, declareList, boxNoList, readOnly} = this.state;
        const props = {
            name: 'file',
            withCredentials: true,
            action: baseUrl + '/api/v1/p/file/upLoad?objectType=ktDeclareFile',
            onChange: this.handleChange,
            onRemove: this.handleRemove,
            onDownload: (file) => {
                let url = file.url;
                if (!file.url && file.response) {
                    url = baseUrl + '/' + file.response.data.filePath;
                }
                window.open(url,"_blank")
            }
        };
        const columns = [
            {
                title: '序号',
                dataIndex: 'index',
                render: (text, record, index) => (
                    <span>{index + 1 + (pageNum - 1) * pageSize}</span>
                )
            }, {
                title: '集装箱号',
                dataIndex: 'boxNo',
            }, {
                title: '报关代码',
                dataIndex: 'declareCode',
            }, {
                title: '报关单号',
                dataIndex: 'declareNo',
            }, {
                title: '货值',
                dataIndex: 'boxValue',
            }, {
                title: '币制',
                dataIndex: 'currency',
            }, {
                title: '票数',
                dataIndex: 'nums',
            }, {
                title: '报关单',
                dataIndex: 'fileLocation',
                render: (text, record) => {
                    const fileList = [];
                    if (record.fileId && record.fileId != null) {
                        fileList.push({
                            uid: record.fileId,
                            fileId: record.fileId,
                            name: record.fileName,
                            url: baseUrl + '/' + text,
                            objectId: record.id,
                            status: 'done',
                        });
                    }
                    return <Upload {...props} data={{orderId: record.id}} defaultFileList={fileList}
                                   beforeUpload={(f, fList) => this.handleBeforeUpload(f, fList, fileList)}
                                   capture="camera" disabled={readOnly}>
                        {readOnly ? '' : <AuthLinkButton authority="order_edit:declare_edit">
                            <Icon type="upload"/> 上传
                        </AuthLinkButton>}
                    </Upload>
                }
            },
        ];
        if (!readOnly) {
            columns.push({
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    return <span>
                       <AuthLinkButton authority="order_edit:declare_edit"
                                       onClick={() => this.clickUpdate(record)}>修改</AuthLinkButton>
                        <Popconfirm title="是否确定删除?" onConfirm={() => this.delDeclare(record.id)}>
                            <AuthLinkButton authority="order_edit:declare_edit">删除</AuthLinkButton>
                        </Popconfirm>
                    </span>
                }
            })
        }
        return (
            <div className='order-space'>
                {readOnly ? '' : <AuthButton authority="order_edit:declare_edit" type='primary'
                                             onClick={this.clickAdd}>新增</AuthButton>}
                <Table className='common-box-margin-top'
                       columns={columns}
                       bordered
                       dataSource={declareList}
                       rowKey='id'
                       pagination={{
                           current: pageNum,
                           total: total,
                           showQuickJumper: true,
                           onChange: (pageNum) => this.getProducts({id: orderId}, pageNum)
                       }}
                       size="middle"/>
                <DeclareModal onOk={this.onOk} onCancel={this.onCancel} view={view} action={action} record={record}
                              boxNoList={boxNoList}/>
            </div>
        )
    }
}